import { NotificationsCenter } from "../../../components/Notifications";

export default function Notifications() {
  return <NotificationsCenter guard="member" />;
}
